import { render, staticRenderFns } from "./BottomCards.vue?vue&type=template&id=8048e692&scoped=true"
import script from "./BottomCards.vue?vue&type=script&lang=js"
export * from "./BottomCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8048e692",
  null
  
)

export default component.exports